var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.94,286.51S88.65,306.29,88.65,310s-1.87,76.86-.38,81,13.81,8.2,20.53,8.2v1.5H252.07L245,361.14s40.3-1.5,41-4.48S250.65,294,247.29,292.12s-54.54-7.47-60.51-7.47S168.12,282,153.94,286.51Z",
    style: {
      fill: "#D56928",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.72,287.26s5.22,13.06,10.82,24.25,19,26.87,22.39,23.51,6.71-29.48,6.71-35.45V281.66s-10.44,8.58-18.65,8.58S148.72,287.26,148.72,287.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.32,262.26s-9.33,16.79-7.84,19.4,16.42,18.66,16.42,18.66-42.54,63.43-46.64,69.77-4.85,15.67-3,20.9,13.06,10.07,20.9,9.7,13.8-10.08,16-19S147.6,307,149.47,301.81s4.47-9.33,1.86-11.94-12.68-12.31-12.68-12.31,3-2.61,2.61-5.6S134.54,263,129.32,262.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.87,333.15s-29.48,24.26-33.58,26.49-2.24,6.35-.75,7.84,11.19,10.45,15.67,13.43,10.82-2.24,12.31-3-.37-4.11-.37-4.11,11.57-6.34,13.43-12.31a67.4,67.4,0,0,0,2.24-14.18s47,19,58.21,23.13,18.28,4.48,23.51-.74,5.59-16.05,3-21.64-19-10.82-26.49-10.82-60.45-6.35-63.8-5.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.12,297.86s7.08,61.73,59.54,88.1,103.84.72,151-5.46c24.7-3.24,47.61,8.91,71.84,11.45,77.45,8.13,138.24-83.14,127.33-150.28-9.44-58.13-46.58-99.15-114.26-128.43s-114.23-52.56-192.84-25S51.52,217.94,57.12,297.86Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.12,297.86s7.08,61.73,59.54,88.1,103.84.72,151-5.46c24.7-3.24,47.61,8.91,71.84,11.45,77.45,8.13,138.24-83.14,127.33-150.28-9.44-58.13-46.58-99.15-114.26-128.43s-114.23-52.56-192.84-25S51.52,217.94,57.12,297.86Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264.91,
    cy: 175.91,
    r: 44.08,
    transform: "matrix(1, -0.1, 0.1, 1, -15.94, 26.76)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.91,
    cy: 175.91,
    r: 36.53,
    transform: "translate(-24.55 44.26) rotate(-9.13)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "241.61 175.91 264.91 175.91 264.91 209.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.65,152.47s0-5.91-8.28-14.19-13.59-13-13.59-13-4.14,13.59,3.54,21.87a145.27,145.27,0,0,0,18.33,16Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.64,189.39s0-5.91-8.28-14.19-13.59-13-13.59-13-4.14,13.59,3.54,21.87a146.21,146.21,0,0,0,18.33,16Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.13,162.54s.62-5.88,9.73-13.24,14.89-11.49,14.89-11.49,2.68,14-5.84,21.37A145,145,0,0,1,97,173.12Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.62,206.14s1.24-5.78,11.06-12.14,16-9.87,16-9.87,1.2,14.16-8,20.65a145.39,145.39,0,0,1-21.26,11.76Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.35,253.67s0-5.91,8.27-14.18,13.6-13,13.6-13,4.14,13.6-3.55,21.87a144.76,144.76,0,0,1-18.32,16Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.21,265.28s.84-5.85-6.18-15.22-11.61-14.81-11.61-14.81-6,12.87.41,22.16a145.57,145.57,0,0,0,15.87,18.4Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.05,299.66s0-5.91,8.27-14.18,13.6-13,13.6-13,4.14,13.6-3.55,21.87a144.76,144.76,0,0,1-18.32,16Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.57,330.84S82.08,325.12,88,315s9.86-16,9.86-16,7.44,12.11,2.11,22.06a145.52,145.52,0,0,1-13.69,20.08Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4,151a168.79,168.79,0,0,1-2.27,18.35c-3.27,16.9-11.45,27.81-14.72,43.07s6.12,34.94,3.61,54.55-10.15,30.51-8,43.6,13.63,48.52,13.63,48.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.05,
    y1: 166.47,
    x2: 106.97,
    y2: 159.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.46,
    y1: 158.59,
    x2: 94.73,
    y2: 151.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.91,211.68s7.46-5.6,15.14-11.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.64,200s-6.22-12.2-13.27-20.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.64,262.08a92.6,92.6,0,0,1,16-21.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.19,270.38A105.09,105.09,0,0,0,77.1,255c-4.36-6.43-5-7.26-5-7.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.05,310.53a99.05,99.05,0,0,1,6.72-13.6,87.45,87.45,0,0,1,8.71-11.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.27,341.13s-.87-7.08,2.24-13.09,6.63-13.9,8.09-17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.46,231.44s-.65-3.7,3.65-9.79S55.22,212,55.22,212s4.07,8.07.15,14.1a92.39,92.39,0,0,1-9.76,12Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,253.29s-.65-3.71,3.64-9.8,7.12-9.63,7.12-9.63,4.07,8.08.15,14.1a92.06,92.06,0,0,1-9.76,12Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.88,237.7s-1-3.62-7.54-7.24-10.59-5.6-10.59-5.6-.16,9,6,12.78a93.1,93.1,0,0,0,14,6.57Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.71,263.46s-1.41-3.49-8.26-6.41-11.12-4.44-11.12-4.44.79,9,7.29,12.07a92.86,92.86,0,0,0,14.61,5.07Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.16,293.57s-.64-3.71-6.73-8-9.94-6.68-9.94-6.68-1.12,9,4.6,13.33a92.32,92.32,0,0,0,13.22,8Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5,300.83s-1.16-3.58,2.22-10.21,5.68-10.55,5.68-10.55,5.17,7.42,2.15,13.94a92.73,92.73,0,0,1-8,13.26Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.89,330.73s.43-3.74,6.26-8.37,9.54-7.23,9.54-7.23,1.63,8.89-3.83,13.57a93.1,93.1,0,0,1-12.74,8.76Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.35,321.51s-.64-3.71-6.73-8-9.93-6.68-9.93-6.68-1.12,9,4.59,13.33a92.15,92.15,0,0,0,13.23,8Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,341.66s.32-3.75-4.48-9.44-7.92-9-7.92-9-3.36,8.4,1.07,14.06A93,93,0,0,0,72.7,348.41Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.82,230.57a106.66,106.66,0,0,0,3.42,11.27c3.88,10.24,10.19,16.19,13.9,25.41s0,22.57,3.66,34.59,9.68,18,9.73,26.48-3.28,31.91-3.28,31.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.35,
    y1: 240.15,
    x2: 40.02,
    y2: 236.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.24,
    y1: 235.26,
    x2: 46.86,
    y2: 230.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.76,266.86s-5.29-2.7-10.71-5.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.15,260a76.07,76.07,0,0,1,6.12-14.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.89,298.87a58.77,58.77,0,0,0-12.34-11.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7,303.92a66.35,66.35,0,0,1,3.4-10.5c2-4.51,2.34-5.1,2.34-5.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.25,334.72s4.19-5.14,6.81-7.07a36.72,36.72,0,0,0,4.42-3.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.53,328.32a63.67,63.67,0,0,0-5.69-7.8,55.83,55.83,0,0,0-6.7-6.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7,348.41a16.13,16.13,0,0,0-2.82-8c-2.61-3.44-5.68-8-6.92-9.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.26,400.66H62.57a2.81,2.81,0,0,1-2.81-2.81l-5.41-41.71h54.13l-5.41,41.71A2.81,2.81,0,0,1,100.26,400.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,363.2H54.35A4.24,4.24,0,0,1,50.11,359h0a4.23,4.23,0,0,1,4.24-4.23H108a4.23,4.23,0,0,1,4.24,4.23h0A4.24,4.24,0,0,1,108,363.2Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382,366l16.6,26.74a5.12,5.12,0,0,1-4.35,7.82h-33.9a5.12,5.12,0,0,0,4.35-7.8l-16.06-26.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.01 365.98 348.65 366.58 354.83 376.64 388.62 376.64 382.01 365.98",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.27,
    y: 252.2,
    width: 141.78,
    height: 119.74,
    rx: 2.91,
    transform: "translate(722.32 624.14) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.91,
    y: 252.2,
    width: 141.78,
    height: 119.74,
    rx: 2.91,
    transform: "translate(711.6 624.14) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,252.2H421.92a4.76,4.76,0,0,1,4.77,4.76v93.53H284.91V257A4.76,4.76,0,0,1,289.67,252.2Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.86,
    y: 256.96,
    width: 129.87,
    height: 86.98,
    transform: "translate(711.6 600.91) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.42,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.92,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.42,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.92,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.42,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.92,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.42,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.92,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.42,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.92,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.42,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.92,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.42,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.91,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.41,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.91,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.41,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.91,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.41,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.91,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.41,
    y: 394.55,
    width: 4.12,
    height: 1.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.29,
    y: 396.12,
    width: 119.25,
    height: 4.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.45,
    y: 396.12,
    width: 29.09,
    height: 4.45,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.55,247.65s5.11-8.83,7-5.11,1.4,11.61-1.39,15.33-3.72,5.57-5.11,2.78S192.55,247.65,192.55,247.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.7,254.61s-6-7.43-7.44-2.32,5.58,11.61,7.44,12.54a9,9,0,0,0,4.64.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.94,286.51S88.65,306.29,88.65,310s-1.87,76.86-.38,81,13.81,8.2,20.53,8.2v1.5H252.07L245,361.14s40.3-1.5,41-4.48S250.65,294,247.29,292.12s-54.54-7.47-60.51-7.47S168.12,282,153.94,286.51Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.33,400.69c-90.47-33.25-86.43-50.19-86.43-50.19l-30,45.85a39,39,0,0,0,12.92,2.84v1.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.93,304.44s30.71-1.62,50.91-16.16L183.28,281Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153.94,286.51S88.65,306.29,88.65,310s-1.87,76.86-.38,81,13.81,8.2,20.53,8.2v1.5H252.07L245,361.14s40.3-1.5,41-4.48S250.65,294,247.29,292.12s-54.54-7.47-60.51-7.47S168.12,282,153.94,286.51Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.72,
    y1: 342.76,
    x2: 233.02,
    y2: 310.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.08,311.38s17.83,10,23.54,33.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,355.91s-11.94,7.84-14.55,9.7-3.36,21.65-.75,27.24,13.81,8.21,21.27,4.48,10.82-21.27,8.21-30.22S101,355.91,101,355.91Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.62,290.24s1.12,17.91,4.47,29.85,9.7,27.61,9.7,27.61l21.27-16.79L208.79,338s-5.59-29.47-9.7-39.17-12.31-17.54-12.31-17.54S155.44,277.18,144.62,290.24Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.72,287.26s5.22,13.06,10.82,24.25,19,26.87,22.39,23.51,6.71-29.48,6.71-35.45V281.66s-10.44,8.58-18.65,8.58S148.72,287.26,148.72,287.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.64,281.66s-10.44,8.58-18.65,8.58-21.27-3-21.27-3,2.65,6.63,6.2,14.49a31.19,31.19,0,0,0,21.83,4.9c4.68-.74,8.6-3.29,11.89-6.81V281.66Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,281.66s-10.44,8.58-18.65,8.58-21.27-3-21.27-3,2.65,6.63,6.2,14.49a31.19,31.19,0,0,0,21.83,4.9c4.68-.74,8.6-3.29,11.89-6.81V281.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.72,287.26s5.22,13.06,10.82,24.25,19,26.87,22.39,23.51,6.71-29.48,6.71-35.45V281.66s-10.44,8.58-18.65,8.58S148.72,287.26,148.72,287.26Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.3,250.9s7.9,26,13,33,19.05,13.94,29.27,13.47,18.58-10.68,20.44-20.9.46-33.45.46-33.45-1.85-10.22-9.75-23.69-47.85-2.33-52,7.89S130.3,250.9,130.3,250.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.89,271.34s4.65,6.5,10.22-.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.49,261.12s4.18-3.72,9.76,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.51,258.33s1.86-3.72,8.82-3.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.17,253.68s2.79-4.64,12.08-5.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.354970932006836px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,252.26s4.52-9.39,12.59-6.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.354970932006836px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.58,282A2.57,2.57,0,1,1,170,279.7,2.45,2.45,0,0,1,172.58,282Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.53,262.51a1.41,1.41,0,1,1-1.41-1.4A1.41,1.41,0,0,1,157.53,262.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,257.26a1.41,1.41,0,1,1-1.4-1.41A1.4,1.4,0,0,1,182,257.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.14,194.69H135.88c-9.29,0-21.37,24.62-20.91,36.23s10.69,19.05,13.48,20.44,7.89,3.72,7.89,2.32,5.58-12.54,5.58-12.54-1.4,6.51,2.32,6.51,15.33-12.08,15.33-12.08.47,9.75,4.18,9.75,11.62-14.4,11.62-14.4l8.36,9.29,2.79-5.57s3.25,13,6,13,5.11-6.51,6.51-13,4.18-17.19-.47-26.95-18.11-18.58-29.26-18.58S152.14,194.69,152.14,194.69Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.39,198.4s-11.44,1.32-16.72,4.84a19.32,19.32,0,0,0-7,7.92l11.44-5.28s-7.48,5.72-8.36,8.36A72.24,72.24,0,0,0,124,222.6l7-2.2s-2.91,2.44-2.64,4.84,1.32,7.92,1.32,7.92l8.36-7.92,2.2,5.72,7-5.72.44,4.4,4.84-6.6,4,4,2.64-4.84s2.2,2.2,3.08-3.08,1.32-7.48,1.32-7.48l4.84,5.72,1.76,7.48,1.32-7.92,4,3.52,1.32-6.6,4.84,2.64,1.76-6.16,10.56,3.52s-3.08-11-5.72-14.08-15.4-4.4-15.4-4.4l-1.32-2.2s-15,3.08-16.72,4a20,20,0,0,0-4,3.08",
    style: {
      fill: "none",
      stroke: "#6b6b6b",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.87,277.93a10.17,10.17,0,0,1-2.61-6.72c0-4.1,4.48-13,5.6-13s3.35,2.23,3.35,2.23-1.86,9-2.61,12.32A9.1,9.1,0,0,1,118.87,277.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.48,281.66s-3.73-4.48-3.73-6.34,6-14.93,7.46-14.93,6,1.87,7.09,2.62.75,4.47.75,7.09-6.72,14.17-6.72,14.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.32,262.26s-9.33,16.79-7.84,19.4,16.42,18.66,16.42,18.66-42.54,63.43-46.64,69.77-4.85,15.67-3,20.9,13.06,10.07,20.9,9.7,13.8-10.08,16-19S147.6,307,149.47,301.81s4.47-9.33,1.86-11.94-12.68-12.31-12.68-12.31,3-2.61,2.61-5.6S134.54,263,129.32,262.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.21,381.66c2.24-9,22.39-74.63,24.26-79.85s4.47-9.33,1.86-11.94c-2.35-2.35-10.74-10.44-12.38-12h-.06c1.46,1.91,9.18,12.25,8.38,18.23-.88,6.6-34.76,86.25-39.16,91.53-3.37,4-12.38,6.52-16.44,7.47a29.74,29.74,0,0,0,17.5,5.6C117,400.31,123,390.61,125.21,381.66Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.21,381.66c2.24-9,22.39-74.63,24.26-79.85s4.47-9.33,1.86-11.94c-2.35-2.35-10.74-10.44-12.38-12h-.06c1.46,1.91,9.18,12.25,8.38,18.23-.88,6.6-34.76,86.25-39.16,91.53-3.37,4-12.38,6.52-16.44,7.47a29.74,29.74,0,0,0,17.5,5.6C117,400.31,123,390.61,125.21,381.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.32,262.26s-9.33,16.79-7.84,19.4,16.42,18.66,16.42,18.66-42.54,63.43-46.64,69.77-4.85,15.67-3,20.9,13.06,10.07,20.9,9.7,13.8-10.08,16-19S147.6,307,149.47,301.81s4.47-9.33,1.86-11.94-12.68-12.31-12.68-12.31,3-2.61,2.61-5.6S134.54,263,129.32,262.26Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.91,270.47,133.05,275l5.6,2.61.24.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.1,339.5s3.36-5.6,7.47-7.09,20.15-3,26.49-.75,10.07,10.45,11.19,14.92.75,10.83-3,14.18-8.58,2.62-13.81,1.12-15.67-7.46-21.27-10.82S246.48,341.73,246.1,339.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.87,333.15s-29.48,24.26-33.58,26.49-2.24,6.35-.75,7.84,11.19,10.45,15.67,13.43,10.82-2.24,12.31-3-.37-4.11-.37-4.11,11.57-6.34,13.43-12.31a67.4,67.4,0,0,0,2.24-14.18s47,19,58.21,23.13,18.28,4.48,23.51-.74,5.59-16.05,3-21.64-19-10.82-26.49-10.82-60.45-6.35-63.8-5.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.54,369.72a15.59,15.59,0,0,0,3.78-7.13c-19.63-1.21-77.21-23-83-23.38-6.6-.44-7.48,9.68-14.09,18S180.71,367.81,175,368.69c-3.9.6-4.52,5.5-4.53,8.56,1.8,1.49,3.49,2.82,4.75,3.66,4.48,3,10.82-2.24,12.31-3s-.37-4.11-.37-4.11,11.57-6.34,13.43-12.31a67.4,67.4,0,0,0,2.24-14.18s47,19,58.21,23.13S279.31,374.94,284.54,369.72Z",
    style: {
      fill: "#D56928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.54,369.72a15.59,15.59,0,0,0,3.78-7.13c-19.63-1.21-77.21-23-83-23.38-6.6-.44-7.48,9.68-14.09,18S180.71,367.81,175,368.69c-3.9.6-4.52,5.5-4.53,8.56,1.8,1.49,3.49,2.82,4.75,3.66,4.48,3,10.82-2.24,12.31-3s-.37-4.11-.37-4.11,11.57-6.34,13.43-12.31a67.4,67.4,0,0,0,2.24-14.18s47,19,58.21,23.13S279.31,374.94,284.54,369.72Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.87,333.15s-29.48,24.26-33.58,26.49-2.24,6.35-.75,7.84,11.19,10.45,15.67,13.43,10.82-2.24,12.31-3-.37-4.11-.37-4.11,11.57-6.34,13.43-12.31a67.4,67.4,0,0,0,2.24-14.18s47,19,58.21,23.13,18.28,4.48,23.51-.74,5.59-16.05,3-21.64-19-10.82-26.49-10.82-60.45-6.35-63.8-5.23Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 187.15,
    y1: 373.82,
    x2: 182.3,
    y2: 376.06,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.96 340.99 202.82 347.33 208.05 349.94 205.06 337.63 200.96 340.99",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.4,
    cy: 335.58,
    rx: 8.77,
    ry: 6.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.61,
    y1: 400.66,
    x2: 443.33,
    y2: 400.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.177485466003418px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeout);
export default __webpack_public_path__ + "static/media/Timeout.4abd6e3d57d2f6ca429521a25319f1aa.svg";
export { ForwardRef as ReactComponent };